import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ToggleHide, ToggleShow } from 'src/app/shared/ui/spinner/redux/spinner.actions';
import { SmartCleanService } from '../../services/smart-clean.service';
import { CleanScoreStateModel } from './clean-score-state.model';
import {
  LoadSmartCleanRecords,
  LoadSmartCleanRecordsFail,
  LoadSmartCleanRecordsSuccess,
  PatchCleanScore,
  PatchCleanScoreFail,
  PatchCleanScoreSuccess,
  RemoveCleanScore
} from './clean-score.actions';

@State<CleanScoreStateModel>({
  name: 'smartCleanRecord',
  defaults: {
    smartCleanRecords: undefined,
    error: null
  }
})
@Injectable()
export class CleanScoreState {
  constructor(
    private service: SmartCleanService,
    private toastrService: NbToastrService
  ) {}

  @Selector()
  public static smartCleanRecords(state: CleanScoreStateModel) {
    return state.smartCleanRecords;
  }

  @Action(LoadSmartCleanRecords)
  public async loadSmartCleanRecords(_ctx: StateContext<CleanScoreStateModel>, { robotId }: any) {
    this.service.loadSmartCleanRecordsAmplify(robotId);
  }

  @Action(LoadSmartCleanRecordsSuccess)
  public loadSmartCleanRecordsSuccess(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      smartCleanRecords: payload
    });
  }

  @Action(LoadSmartCleanRecordsFail)
  public loadSmartCleanRecordsFail(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    this.toastrService.show(status, $localize`Fetching Smart Clean Record Failed: ${payload}`, {
      status: 'danger'
    });
    ctx.dispatch(ToggleHide);
  }

  @Action(PatchCleanScore)
  public async patchCleanScore(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    ctx.dispatch(ToggleShow);
    if (payload.pmap_id) {
      this.service.patchCleanScoreAmplify(payload);
    } else {
      this.service.patchCleanScoreP2mapAmplify(payload);
    }
  }

  @Action(PatchCleanScoreSuccess)
  public async patchCleanScoreSuccess() {
    this.toastrService.success('', $localize`Clean Scores Updated Successfully`, { preventDuplicates: true });
  }

  @Action(PatchCleanScoreFail)
  public async PatchCleanScoreFail(ctx: StateContext<CleanScoreStateModel>, { payload }: any) {
    this.toastrService.show(status, $localize`Patching Clean Score Record Failed: ${payload}`, {
      status: 'danger'
    });
    ctx.dispatch(ToggleHide);
  }

  @Action(RemoveCleanScore)
  public async removeCleanScores(ctx: StateContext<CleanScoreStateModel>) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      smartCleanRecords: undefined
    });
    ctx.dispatch(ToggleHide);
  }
}
